import {
  DatePickerProps as MantineDatePickerProps,
  DatePicker as MantineDatePicker,
} from '@mantine/dates';

export type DatePickerProps = MantineDatePickerProps;

export const DatePicker = MantineDatePicker;

DatePicker.displayName = 'DatePicker';
